import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /upload is the legacy nav-hub for the per-entity upload forms shipped
 * under task #12. Slice B of the dashboard-upload work consolidated all
 * six entities (batch, exam, student, teacher, news, reportcard) into
 * the single /dashboard-upload screen, so this route is now just a
 * redirect for any lingering bookmarks. The form components themselves
 * stay in the codebase — the dashboard reuses them in its per-entity
 * Sheet workspaces.
 */
export const Route = createFileRoute("/_app/_support/upload/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard-upload" });
  },
});
